import { Timeline, TimelineStep } from '@interfaces/models/timeline';
import { Order } from '@interfaces/models/myOrder';
import { Product } from '@interfaces/models/orderSaleProduct';
import { currentStepId } from '../helper';
import styles from '../product-timeline.module.scss';
import OutlineView from './outline';
import StepInfoView from './step-info';

const StepView: React.FC<{
  order: Order | null;
  product: Product;
  step: TimelineStep;
  timeline: Timeline;
}> = ({ product, order, step, timeline }) => {
  const { identifier, status } = step;

  const currentStep = status === 'pending' || status === 'ongoing' || status === 'cancelled';

  return (
    <div
      key={identifier}
      id={currentStep ? currentStepId : ''}
      className={styles.ordersSales__mainRight__steps__step}
    >
      <OutlineView step={step} />
      <StepInfoView
        order={order}
        product={product}
        step={step}
        timeline={timeline}
      />
    </div>
  );
};

export default StepView;
